import { StackProps } from "@mui/material";
import { ModalMontoFieldProps } from "./types";
import { MontoRequest } from "@/shared/types/monto";
import { getMontoMonedaCantidad } from "@/features/monetizacion/shared/utils";
import { useEffect } from "react";
import MontoFieldModalFormObjectiveFields from "./monto-field-modal-form-objective-fields";
import MontoFieldModalFormNormalFields from "./monto-field-modal-form-normal-fields";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { z } from "zod/v4";
import { Form, useForm } from "@/components/form";

interface MontoFieldModalFormProps extends StackProps, ModalMontoFieldProps {

}

const baseMontoFieldModalFormSchema = z.object({
    items: z.array(z.object({
        monedaId: z.string().nonempty("Este campo es requerido"),
        cantidad: z.number().or(z.literal(""))
    }))
})

export default function MontoFieldModalForm({
    moneda,
    value,
    onValueChange,
    objective,
    objectiveFilled,
    emotionalDamage,
    allowNegative,
    decimalScale,
    ...props
}: MontoFieldModalFormProps) {
    const { monedas } = useMonetizacion();;
    const filteredMonedas = monedas.filter(m => !m.hidden);

    const form = useForm({
        onSubmit: ({ value }) => {
            const finalValue = baseMontoFieldModalFormSchema.parse(value);
            finalValue.items = finalValue.items.filter(vi => vi.cantidad !== "" && vi.cantidad);
            onValueChange(finalValue as MontoRequest)
        },
        defaultValues: {
            items: filteredMonedas.map(m => ({
                monedaId: m.id,
                cantidad: value ? (getMontoMonedaCantidad(value, m.id) || "") : ""
            }))
        },
        enterBehaviour: "selectNext",
        submitOnce: true,
        closeModalOnSubmit: true
    })

    useEffect(() => {
        form.focusField("items[0].cantidad", true)
    }, []);

    return <Form gap={2} form={form} {...props}>
        {
            objective != null ?
                <MontoFieldModalFormObjectiveFields
                    objective={objective}
                    objectiveFilled={objectiveFilled}
                    emotionalDamage={emotionalDamage}
                    monedas={filteredMonedas}
                    allowNegative={allowNegative}
                    decimalScale={decimalScale}
                /> :
                <MontoFieldModalFormNormalFields
                    monedas={filteredMonedas}
                    allowNegative={allowNegative}
                    decimalScale={decimalScale}
                />
        }
        <Form.SubmitButton size="small">Confirmar</Form.SubmitButton>
    </Form>
}